import {
    postFindInsuranceCompanies,
    postFindHolders,
    postFindByCondition
} from "./api/commondata"

class CommonDataService {
    async findSalesmans(){
        var requestBody = {
            query_data :{
                source: 'salesmans',
                fields: 'id,name'
            }}
        return await postFindByCondition(requestBody)
    }

    async findAgencyCompanies(){
        var requestBody = {
            query_data :{
                source: 'agency_companies',
                fields: 'id,name'
            }}
        return await postFindByCondition(requestBody)
    }

    async findHolders(){
        return await postFindHolders();
    }

    async findInsuranceCompanies(){
        return await postFindInsuranceCompanies()
    }
}

export default new CommonDataService();